import { ReleaseNote } from '@lib-ui/lib/models/release-note';

export const ReleaseNotes: ReleaseNote[] = [
  {
    version: '1.0',
    changes: [
      'Initiale Bereitstellung',
    ],
    date: '05.01.2021',
  },
  {
    version: '1.1',
    changes: [
      'Funktionalität Massenupload',
    ],
    date: '25.03.2021',
  },
  {
    version: '1.2',
    changes: [
      'Erweiterung ZApp um Zweitarifzähler Strom',
    ],
    date: '25.05.2021',
  },
  {
    version: '1.3',
    changes: [
      'Anpassung Rollenkonzept gemäß Fachkonzept',
      'Backendimplementierung Suchfunktion + mehrere Filterkriterien',
      'Erweiterung View um weiere Spalten Zählerstand, WE, PLZ, Zählerart.',
      'Optimierung der Laufzeiten',
      'Änderung der Feldanordnung/ Kleinere Darstellung Zähler + Darstellung Auftragserstellung im Popup',
      'Bereits disponierte Aufträge können an andere Techniker vergeben werden',
      'Der Techniker bekommt eine Nachricht per E-mail, wenn ein Auftrag eingestellt wurde',
      'Die Auftragshistorie abgeschlossener Aufträge ist für den Techniker in der App einsehbar',
      'Informationen zum Standort des Zählers können in der App für den Techniker verfügbar gemacht werden/ Erweiterung Massenupload',
      'Anpassen der bestehenden Dokumentationen',
    ],
    date: '21.11.2022',
  },
  {
    version: '1.4.1',
    changes: [
      'Disponenten können selbst einen Auftrag bearbeiten',
      'Dispofunktion: Rückgemeldeter Auftrag kann an den Servicetechniker zurückgeben werden (z.B. wenn ein falsches Foto zugeordnet ist)',
      'Button für Download der Auftragsliste im Dispo-Tool',
      'Anpassung GoogleMaps-Integration',
    ],
    date: '12.12.2022',
  },
  {
    version: '1.4.2',
    changes: [
      'Verbesserter Workflow der App',
      'Neuen Zähler anlegen in der App',
      'Verbesserte Fehlermeldungen für den User',
      'Verbessertes Logging im Backend und Frontend',
    ],
    date: '03.01.2023',
  },
  {
    version: '1.5',
    changes: [
      'Sichereres Anmeldeverfahren B2C',
    ],
    date: '30.08.2023',
  },
  {
    version: '1.6',
    changes: [
      'Bereitstellung Prozess Zählerinstallation in der ZApp',
    ],
    date: '08.05.2024',
  },
  {
    version: '1.7',
    changes: [
      'Fotoupload im Dispo-Tool',
      '"meterNotes" als Bemerkungsfeld im Excelimport-/export',
    ],
    date: '14.01.2025',
  },
  {
    version: '1.7.1',
    changes: [
      'Fehlerbehung: Zählerstand wird nicht angezeigt und kann nicht bearbeitet werden',
    ],
    date: '16.01.2025',
  },
];
